export default "Guide du process en assemblée générale : note de convocation, présentation, résolution et vote des travaux de rénovation énergétique en copropriété. Modèles et accompagnement.";
